<template>
  <Modal v-model="modal" :title="$t('title.w42')">
    <Row type="flex" justify="center" align="middle">
      <Col span="7" class="label">
        {{$t('label.w126')}}
      </Col>
      <Col span="17" class="checkbox">
        <Checkbox v-model="CanSendEmail">{{$t('option.w48')}}</Checkbox>
        <Checkbox v-model="CanSendSms">{{$t('option.w49')}}</Checkbox>
      </Col>
    </Row>
    <template slot="footer">
      <Button type="primary" :loading="loading" @click="submit">{{$t('btn.b36')}}</Button>
    </template>
  </Modal>
</template>
<script>
export default {
  data(){
    return {
      modal:false,
      loading:false,
      CanSendSms:false,
      CanSendEmail:false
    }
  },
  methods:{
    async getdata(){
      let res=await this.$axios.get('/Member/RZJInfoCenter/UserInfoEmailSms')
      if(res.err) return;
      this.CanSendSms=res.CanSendSms
      this.CanSendEmail=res.CanSendEmail
    },
    async submit(){
      this.loading=true
      let res=await this.$axios.post('/Member/RZJInfoCenter/UpdateEmailSms',{
        canSendSms:this.CanSendSms,
        canSendEmail:this.CanSendEmail
      })
      this.loading=false
      res.throw()
      if(!res.err) this.modal=false
    }
  }
}
</script>
<style lang="less" scoped>
.label{
  color: #232325;
}
.mb{
  margin-bottom: 20px;
}
/deep/ .ivu-checkbox-wrapper{
  font-size: 14px;
  margin-right: 20px;
}
</style>
